var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tnc-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", { staticStyle: { "font-size": "16pt" } }, [
        _vm._v("利用規約"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("一般規則"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "当社のウェブサイトは、個人の居住地の管轄区域で定められた法定年齢に達した個人のみに限定されています。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "当ウェブサイトは、当ウェブサイトを利用するユーザーによって侵害される国内法、連邦法、または国際法について一切責任を負いません。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ユーザーは自身の行動に責任を持ち、州法や法的問題を含む自国の法律に拘束されます。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "すべてのエージェントはそれぞれのメンバーのアカウントに対して責任を負い、エージェントが提出したすべての確定した賭けを尊重するものとします。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "エージェントは当サイトのパートナーではありません。そのため、プレイヤーとエージェント間の不一致や紛争について、当サイトは一切責任を負いません。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ユーザーIDとパスワードを不正使用から守ることは、ユーザーの責任です。ユーザーIDとパスワードが盗難または不正アクセスされた場合、ユーザーは直ちに代理店に連絡する責任があります。代理店がユーザーIDとパスワードを変更します。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ユーザー ID とパスワードが盗まれた場合、ユーザーはそれぞれのアカウントに対して責任を負い、提出された確認済みの賭け金をすべて尊重するものとします。"
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("ゲームルール"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "当社ウェブサイトによって決定されたゲーム結果は最終的かつ拘束力を持つものとなります。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "いかなる紛争が発生した場合でも、当社ウェブサイトの管理者とプレイヤーは、当社ウェブサイトの取引ログデータベースが紛争の最終裁定者となることに同意するものとします。すべての紛争は、試合結果が確定した当日中に申し立てを行う必要があります。試合日以降は、いかなる申し立ても受け付けられません。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "プレイヤーは自身のアカウント取引の正確性を確認する責任を単独で負います。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "コンピューターで賭けを送信する前に、間違いや記入漏れがないか必ずご確認ください。コンピューターで賭けが承認されると、変更やキャンセルはできません。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "当社は、本利用規約に違反している、詐欺行為、不法侵入、攻撃、偽造、標準ルールの破壊、またはシンジケート賭博に関与していることが判明した顧客のアカウントを凍結またはキャンセルする権利を留保し、その結果生じたすべてのアカウント残高を事前の通知なしに凍結および没収する権利を有します。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "当社は、シンジケートベッティング、組織的または協調的な賭け、共謀、不正行為、システムの悪用、技術的な不具合や誤ったオッズの利用、またはその他の不当な利益を得る行為に関連すると判断されたベットまたはベットチケットを無効または取り消す権利を留保します。関連する払戻金または勝利金は取り消される場合があり、該当するアカウントは停止または閉鎖される場合があります。"
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("制限と責任"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "上記の一般性を損なうことなく、当社ウェブサイトは、妨害行為、不可抗力、および/または当社ウェブサイトの中央コンピュータ システムや記録またはその一部の故障、損傷、破壊、または電気通信またはデータ送信システムの故障に起因する遅延、損失、エラー、脱落、またはその他の遅延、または特定のレースへのエントリーが受領されない結果となる遅延が発生した場合、いかなる人物に対しても責任を負いません。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "当社ウェブサイトは、天災、戦争勃発、暴動、内乱、テロ行為、政府または当局の行為（ライセンスまたは同意の拒否または取消を含む）、火災、爆発、洪水、盗難、悪意ある損害、ストライキ、ロックアウト、およびあらゆる種類の労働争議の結果として生じた損失については一切責任を負いません。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ネットワーク接続、通信、システム、または人為的なエラーにより、ダブルベットの受付、ベットの確認ができない、ゲーム開始後にベットを行うなど、ベット関連の問題が発生した場合、当社は、当該エラーが発生した場合、ケースバイケースで対応し、エラーを修正するためのその他の措置を講じる権利を留保します。当社は、当該エラーに関して、お客様または第三者に対して一切の責任を負いません。お客様が当該エラーを経験し、アップラインに報告せずにベットを継続した場合、当該エラーが再度発生した場合、お客様の責任となり、すべての勝敗結果が適用されます。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "本規則および規制は、当事者間の完全な合意および理解を構成します。"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "本規則および規制の英語版と他の言語版との間に矛盾がある場合、英語版が他の言語版に優先し、正確かつ有効とみなされます。"
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }